var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { $patients } from 'ziphy-web-shared/basic/entities/patients';
import { useForm } from 'ziphy-web-shared/basic/lib/forms';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { Button } from '@booking/pages/liveqHome/liveqSteps/components/button';
import { EligibilityStep } from '@booking/pages/liveqHome/liveqSteps/components/forms/eligibilityStep/EligibilityStep';
import { FormQuestion } from '@booking/pages/liveqHome/liveqSteps/components/forms/formStep/FormQuestion';
import { InfoStep } from '@booking/pages/liveqHome/liveqSteps/components/forms/infoStep/InfoStep';
import { $liveqBooking } from '@store';
import { ProgressLine } from './components/progressLine';
import styles from './index.module.scss';
export const Steps = () => {
    // const { step, subStep, back, data } = useSteps()
    const getContent = (id) => {
        return $liveqBooking.content.find(item => { var _a; return ((_a = item.parents.at(-1)) === null || _a === void 0 ? void 0 : _a.id) === id; });
    };
    const [isLoading, setLoading] = useState(0);
    // @ts-ignore
    const { token } = useParams();
    const { form } = useForm({ answers: { value: [] } });
    const currentQuestions = $liveqBooking.currentQuestons;
    const currentButtons = $liveqBooking.currentButtons;
    const stepsCount = useMemo(() => {
        return $liveqBooking.branches.filter(branch => branch.variation === 'step').length;
    }, []);
    const current = useMemo(() => {
        if (!$liveqBooking.survey.next_step_id) {
            return stepsCount;
        }
        return $liveqBooking.survey.answers.length;
    }, [$liveqBooking.survey.next_step_id, stepsCount]);
    const getButtonLabel = (button) => {
        var _a;
        if (button.action === 'back') {
            return 'Back';
        }
        return (_a = getContent(button.id)) === null || _a === void 0 ? void 0 : _a.label;
    };
    useEffect(() => {
        form.fields.answers.setValue([]);
    }, [$liveqBooking.survey.next_step_id]);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        e.preventDefault();
        const button_id = (_b = (_a = e.nativeEvent) === null || _a === void 0 ? void 0 : _a.submitter) === null || _b === void 0 ? void 0 : _b.value;
        const button = currentButtons.find(el => el.id === button_id);
        setLoading(button_id);
        try {
            if (button.action === 'back') {
                yield $liveqBooking.answer(button_id, [], token);
            }
            else {
                yield $liveqBooking.answer(button_id || null, form.fields.answers.value, token);
            }
            // if (validate()) {
            //   // next()
            // }
        }
        catch (e) { }
        setLoading(0);
    });
    const formStatus = $liveqBooking.resultType;
    return (_jsx("div", Object.assign({ className: styles.steps }, { children: _jsxs("div", Object.assign({ className: styles.stepsContent }, { children: [_jsx(ProgressLine, { label: '1. Check Eligibility', segments: 2, currentSegment: 0, warning: formStatus === 'warning', count: stepsCount, current: current }), formStatus === 'warning' && _jsxs(_Fragment, { children: [_jsx(EligibilityStep, { type: formStatus }), _jsx("div", Object.assign({ className: clsx(styles.button) }, { children: _jsx(Button, { type: "submit", onClick: () => {
                                    $router.executeAutoTarget({ to: '/' }, { type: 'replace' });
                                }, label: 'Back To Home' }) }))] }), formStatus === 'success' && _jsxs(_Fragment, { children: [_jsx(EligibilityStep, { type: formStatus }), $liveqBooking.token && !$auth.isLogged ?
                            _jsx("div", Object.assign({ className: clsx(styles.button) }, { children: _jsx(Link, Object.assign({ to: `/login?referrer=/explore/anonym/${$liveqBooking.survey._id}/${$liveqBooking.token}` }, { children: _jsx(Button, { label: 'Next: Create Account' }) })) }))
                            :
                                _jsx("div", Object.assign({ className: clsx(styles.button) }, { children: _jsx(Button, { type: "submit", loading: isLoading === 999, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                            var _c;
                                            setLoading(999);
                                            try {
                                                if ($liveqBooking.survey.status === 'completed') {
                                                    yield $liveqBooking.submit((_c = $patients.defaultPatient) === null || _c === void 0 ? void 0 : _c.id);
                                                }
                                            }
                                            catch (e) {
                                                setLoading(0);
                                                return;
                                            }
                                            $router.executeAutoTarget({ to: `/explore/consultation/${$liveqBooking.survey.params.consultation_id}` }, { type: 'replace' });
                                        }), label: 'Next: Book Consultation' }) }))] }), !formStatus &&
                    _jsxs("form", Object.assign({ onSubmit: handleSubmit, className: styles.form, noValidate: true }, { children: [currentQuestions.map((item) => {
                                var _a;
                                return (_jsxs("div", { children: [item.subvariation === 'info_question' && _jsx(InfoStep, { question: item }), item.subvariation !== 'info_question' &&
                                            (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.stepsContentTitle }, { children: (_a = getContent(item.id)) === null || _a === void 0 ? void 0 : _a.title })), _jsx(FormQuestion, { onChange: (answers) => {
                                                            form.fields.answers.setValue(answers);
                                                        }, question: item })] }))] }, item.id));
                            }), _jsxs("div", Object.assign({ className: clsx(styles.button) }, { children: [!currentButtons.length && _jsx(Button, { loading: !!isLoading, type: "submit", label: 'Continue' }), currentButtons.length &&
                                        _jsx("div", Object.assign({ className: styles.buttonGap }, { children: currentButtons.map((item) => (_jsx(Button, { primary: item.action !== 'back', style: { marginBottom: '20px' }, loading: isLoading === item.id, type: "submit", value: item.id, label: getButtonLabel(item) }, item.id))) }))] }))] }))] })) })));
};
